export default __webpack_public_path__ + "static/media/UserAvatar.4089eaf7.png";